import { Injectable } from '@angular/core';

@Injectable()
export class UtilService {

  constructor() { }


  validateUndefinedNull(value: any) {
    let valido = false;
    if (value !== undefined && value !== null) {
      valido = true;
    }
    return valido;
  }


  validateCadenaConValor(value: String) {

    let valido = false;
    if (value !== undefined && value !== null && value !== '') {
      valido = true;
    }

    return valido;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/util/util.service.ts